import moment from 'moment'
import { isDate } from './date-util'

export function correctDatesOrder(dates) {
  if (!Array.isArray(dates) || dates.length !== 2 || dates.some(val => !isDate(val))) {
    return dates
  }
  // 将字符串和 Date 类型统一转换为 moment 对象，并排序
  const moments = dates.map((date) => moment(date))

  moments.sort((a, b) => (a.isAfter(b) ? 1 : -1))

  // 将排序后的 moment 对象转换回 Date 类型
  const correctedDates = moments.map((m) => m.toDate())

  return correctedDates
}



// WEBPACK FOOTER //
// ./src/public/components/kye-date-picker2/src/utils/tools.js